<ta-flexbox alignItems="center" justifyContent="center">
  <ng-container *ngFor="let step of steps; index as idx; last as last">
    <ta-step
      [idx]="idx"
      [label]="step.label"
      [active]="step.active"
      [disabled]="step.disabled"
      [completed]="step.completed"
      (taInteract)="setActiveStep(step.value != null ? step.value : idx)"
      class="ph--2"
    >
    </ta-step>

    <div *ngIf="!last" class="border--bottom w--8 h--0"></div>
  </ng-container>
</ta-flexbox>

<p
  *ngIf="steps[activeStep]?.description != null"
  class="color--default f--4 pl--2 pt--6"
>
  {{ steps[activeStep].description }}
</p>
